import React from "react";
import { Box, Typography, Container } from "@mui/material";
import HelpDrawer from "./HelpDrawer";

const HelpScreen: React.FC = () => {
  const [drawerOpen, setDrawerOpen] = React.useState(true);

  const handleDrawerClose = () => {
    setDrawerOpen(false);
  };

  return (
    <Container maxWidth="lg">
      <Box sx={{ mt: 4, mb: 4 }}>
        <Typography variant="h4" component="h1" gutterBottom>
          Help
        </Typography>
      </Box>

      <HelpDrawer open={drawerOpen} onClose={handleDrawerClose} />
    </Container>
  );
};

export default HelpScreen;
